<div class="supply-chain-form-fields" [formGroup]="form">
  <mat-form-field>
    <mat-label>{{ 'Name_tr' | translate }}</mat-label>
    <input autotrim formControlName="name" matInput placeholder="{{ 'name_of_product_or_product_group_tr' | translate }}" />
    <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'hs_code_tr' | translate }}</mat-label>
    <hscode-selector #hsCodeSelector="hscodeSelector" formControlName="hsCode"></hscode-selector>
    @if (hsCodeSelector.hints.length) {
      <!-- One mat-hint per align: Material throws in dev mode on a second one. -->
      <mat-hint class="hs-warning">
        @for (hint of hsCodeSelector.hints; track hint.key) {
          <div>{{ hint.key | translate: hint.params }}</div>
        }
      </mat-hint>
    } @else {
      <mat-hint>{{ 'harmonized_system_code_multiple_tr' | translate }}</mat-hint>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'Article_Number_tr' | translate }} ({{ 'optional_tr' | translate }})</mat-label>
    <app-article-numbers-field
      formControlName="articleNumbers"
      [placeholder]="'add_article_number_tr' | translate"
    ></app-article-numbers-field>
    <mat-hint>{{ 'Type_a_number_and_press_comma_tr' | translate }}</mat-hint>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'Tags_tr' | translate }} ({{ 'optional_tr' | translate }})</mat-label>
    <app-article-numbers-field
      formControlName="tags"
      testId="tag-input"
      [allowSpaces]="true"
      [suggestions]="tagSuggestions"
      [placeholder]="'add_tag_tr' | translate"
    ></app-article-numbers-field>
    <mat-hint>{{ 'tag_hint_tr' | translate }}</mat-hint>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'Reference_tr' | translate }} ({{ 'optional_tr' | translate }})</mat-label>
    <input autotrim formControlName="reference" matInput />
    <mat-hint>{{ 'chain_reference_hint_tr' | translate }}</mat-hint>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'active_from_tr' | translate }} ({{ 'optional_tr' | translate }})</mat-label>
    <input matInput [matDatepicker]="activeFromPicker" formControlName="activeFrom" />
    <mat-datepicker-toggle matIconSuffix [for]="activeFromPicker"></mat-datepicker-toggle>
    <mat-datepicker #activeFromPicker></mat-datepicker>
    <mat-hint>{{ 'active_from_hint_tr' | translate }}</mat-hint>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'Notes_tr' | translate }}</mat-label>
    <textarea autotrim formControlName="notes" matInput></textarea>
    <mat-hint>{{ 'internal_notes_descripion_internal_art_tr' | translate }}</mat-hint>
  </mat-form-field>
</div>
